import React from 'react';
import TypedList from './TypedList';

const OPTIONS = [
  { value: 'home-personal', label: 'Home and Personal Assets' },
  { value: 'business-property', label: 'Business and Property' },
  { value: 'pension-deferred-comp', label: 'Pension and Deferred Compensation' },
  { value: 'cash-value-life', label: 'Cash Value Life' },
  { value: '529-savings', label: '529 Savings Plan' },
  { value: 'future-cash', label: 'Future Assets – Cash' },
  { value: 'future-property', label: 'Future Assets – Property' },
];

const SUB_CATEGORIES = {
  'home-personal': [
    { value: 'home', label: 'Home' },
    { value: 'collectible', label: 'Collectible' },
    { value: 'personal-property', label: 'Personal Property' },
    { value: 'vehicle', label: 'Vehicle' },
    { value: 'other', label: 'Other' },
  ],
};

export default function OtherAssetsStep({ formData, updateFormData }) {
  return (
    <div data-testid="other-assets-step">
      <h2 className="text-2xl font-bold text-[#0f172a] mb-2" style={{ fontFamily: 'Outfit, sans-serif' }}>
        Other Assets
      </h2>
      <p className="text-sm text-[#64748b] mb-6">Add all other assets you own — home, vehicles, business, deferred compensation, etc.</p>
      <TypedList
        title="Assets"
        items={formData.assets}
        onChange={(v) => updateFormData({ ...formData, assets: v })}
        typeOptions={OPTIONS}
        subCategoryMap={SUB_CATEGORIES}
        amountLabel="Estimated Value"
        itemLabel="Asset"
        testIdPrefix="other-asset"
      />
    </div>
  );
}
